import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginAPI } from "../../api/authService";
import { extractBackendRole } from "../../auth";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await loginAPI(email, password);

      if (response.status === 200 || response.status === 202) {
        const {
          Token,
          email,
          user_role,
          user_username,
          vertical_id,
          vertical_key,
          vertical_name,
          user_id,
        } = response.data;

        const role = extractBackendRole(user_role);
        if (!role) {
          setError("Login succeeded but no role was returned by the server.");
          return;
        }

        login(
          {
            user_id,
            user_username,
            email,
            role,
            vertical_id,
            vertical_key,
            vertical_name,
          },
          Token
        );
        if (role === "Hr") {
          navigate("/hr/users");          // HR landing page
        }
        // else if (vertical_key) {
        //   navigate(`/${vertical_key}/inquiries`);
        // }
        else {
          navigate("/dashboard");         // Admin
        }



      }
    } catch (err: any) {
      const apiMessage =
        err?.response?.data?.non_field_errors?.[0] ||
        err?.response?.data?.detail ||
        "Invalid username or password";

      setError(apiMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card shadow-lg">
        {/* LEFT PANEL */}
        <div className="login-left">
          <h2>WELCOME <br></br>TO<br></br>HATCHWAY </h2>
          <p>
            Manage your business operations, users, and workflows from one
            powerful dashboard.
          </p>
        </div>

        {/* RIGHT PANEL */}
        <div className="login-right">
          <h4 className="mb-1">Sign In</h4>
          <p className="text-muted mb-4">
            Enter your credentials to continue
          </p>

          {error && <div className="alert alert-danger py-2">{error}</div>}

          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div className="mb-3">
              <label className="form-label">User Name</label>
              <input
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="hatchway@root"
              />
            </div>

            {/* Password */}
            <div className="mb-2">
              <label className="form-label">Password</label>

              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <span
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  role="button"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </span>
              </div>
            </div>


            {/* Remember */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={remember}
                  onChange={() => setRemember(!remember)}
                />
                <label className="form-check-label">Remember me</label>
              </div>

              <a href="#" className="forgot-link">
                Forgot Password?
              </a>
            </div>

            {/* Button */}
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>

          {/* <div className="text-center mt-4">
            <small className="text-muted">
              © {new Date().getFullYear()} Hatchway
            </small>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
